'use client'
import React from 'react'
import { selectThemeConfig, selectUpdateThemeConfig, useThemeConfig } from '../model'
import { ThemeType } from '@/shared/config/theme/lib/theme'
import { Button } from '@/shared/ui/button'
import { CheckIcon } from 'lucide-react'
import { useTheme } from 'next-themes'
import { cn } from '@/shared/lib/classnames'

// Component for Light Theme Buttons
export function SelectPaletteButton({
  type,
  theme,
  className,
}: {
  type: 'dark' | 'light'
  theme: ThemeType
  className?: string
}) {
  const updateThemeConfig = useThemeConfig(selectUpdateThemeConfig)
  const themeVariants = useThemeConfig(selectThemeConfig)
  const themeVariant = themeVariants[type]
  const { setTheme } = useTheme()
  return (
    <Button
      variant={'defaultGhost'}
      size="lg"
      onClick={() => {
        updateThemeConfig({
          [type]: theme.name[type],
        })
        setTheme(theme.name[type])
      }}
      className={cn(
        'justify-start grow min-w-[120px] sm:w-auto w-full p-4 border-none rounded-sm',
        themeVariant === theme.name[type] && 'border border-primary/60',
        themeVariant !== theme.name[type] && 'bg-transparent',
        className,
      )}
      style={
        {
          '--theme-primary': `hsl(${theme?.activeColor[type]})`,
        } as React.CSSProperties
      }
    >
      <span
        className={cn(
          'mr-1 flex h-5 w-5 shrink-0 -translate-x-1 items-center justify-center rounded-full bg-(--theme-primary)',
        )}
      >
        {themeVariant === theme.name[type] && <CheckIcon className="w-2 h-2 text-white" />}
      </span>
      {theme.label}
    </Button>
  )
}
